export default "__VITE_ASSET__DJyuyNcb__"